<template>
    <div class="common-left">
        <img
          class="back-icon"
          src="@/assets/img/アセット 48@3x.png"
          @click="backToprevious"
        />
    </div>
</template>

<script>
export default {
    name: "Backicon",
    methods: {
        backToprevious() {
            if(this.$route.path === "/Selectsong") {
                this.$emit("allStopSound")
                this.$router.push("/home");
            } else if (this.$route.path === "/Selectedsong") {
                this.$router.push("/Selectsong");
            } else {
                this.$router.push("/home");
            }
        }
    }
}
</script>

<style>
.common-left {
  position: absolute;
  top: -40px;
  left: 10px;
}
.back-icon {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/Backicon.vue